import React from "react";

interface Contact {
    name: string;
    email: string;
}

interface Props {
    contacts: Contact[];
    onChange: (vals: Contact[]) => void;
    disabled: boolean;
    formSubmitted?: boolean; // add this
}

export const ContactsField = ({ contacts, onChange, disabled, formSubmitted }: Props) => {
    const updateContact = (i: number, field: keyof Contact, value: string) => {
        const next = [...contacts];
        next[i] = { ...next[i], [field]: value };
        onChange(next);
    };

    return (
        <div className="mt-6 mb-6">
            <h4 className={`text-lg font-semibold ${disabled ? "text-gray-500" : "text-eq-grey"}`}>Add Contacts</h4>
            <p className={`text-sm mb-4 ${disabled ? "text-gray-400" : "text-gray-500"}`}>
                Provide contact details including a name and email address. This is where emails will be sent when the user uses the "Contact a Human" button.
            </p>
            <div className="grid grid-cols-1 gap-4">
                {contacts.map((contact, i) => (
                    <div key={i} className="grid grid-cols-1 md:grid-cols-2 gap-3">
                        <input
                            type="text"
                            className="mt-1 block w-full rounded-md p-3 border border-gray-400 focus:border-eq-green focus:ring-eq-green"
                            placeholder={`Name ${i + 1}…`}
                            value={contact.name}
                            onChange={e => updateContact(i, "name", e.target.value)}
                            disabled={disabled}
                        />
                        <input
                            type="email"
                            className="mt-1 block w-full rounded-md p-3 border border-gray-400 focus:border-eq-green focus:ring-eq-green"
                            placeholder={`Email ${i + 1}…`}
                            value={contact.email}
                            onChange={e => updateContact(i, "email", e.target.value)}
                            disabled={disabled}
                        />
                    </div>
                ))}
            </div>
        </div>
    );
};
